import { useCurrentSiteId } from '@hotjar/site';

import { useFilterState } from './use-filter-state';
import { useHighlightsList } from './use-highlights-list';

interface FilteredHighlightsList {
  data: ReturnType<typeof useHighlightsList>['data'];
  filters: {
    state: ReturnType<typeof useFilterState>[0];
    actions: ReturnType<typeof useFilterState>[1];
  };
  status: ReturnType<typeof useHighlightsList>['status'];
}

export function useFilteredHighlightsList(
  collectionId: Parameters<typeof useHighlightsList>[1],
  queryParams: Pick<Parameters<typeof useHighlightsList>[2], 'currentPage' | 'itemsPerPage'>,
  resetPage: () => void,
): FilteredHighlightsList {
  const currentSiteId = useCurrentSiteId();
  const [filterState, filterActions] = useFilterState(resetPage);

  const { data, status } = useHighlightsList(currentSiteId, collectionId, {
    ...queryParams,
    ...filterState,
  });

  return {
    data,
    filters: {
      state: filterState,
      actions: filterActions,
    },
    status,
  };
}
